// Product Info Side Modal enhancements
(function() {
  function closeOnEsc(e) {
    if (e.key === 'Escape') {
      const openModal = document.querySelector('dialog.side-modal[open]');
      if (openModal) openModal.close();
    }
  }

  function handleBackdropClick(e) {
    if (e.target.nodeName === 'DIALOG' && e.target.classList.contains('side-modal')) {
      e.target.close();
    }
  }

  function trapFocus(modal) {
    const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    modal.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('dialog.side-modal').forEach(function(modal) {
      modal.addEventListener('click', handleBackdropClick);
      modal.addEventListener('close', function() {
        document.body.classList.remove('modal-open');
      });
      modal.addEventListener('show', function() {
        document.body.classList.add('modal-open');
        trapFocus(modal);
      });
    });
    document.addEventListener('keydown', closeOnEsc);
  });
})();
